/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["entry-description-panel{color:#656565;display:flex;align-items:center;max-width:215px}entry-description-panel .description-text{cursor:text;vertical-align:sub;flex:1 1 auto}"];
export { styles as styles };
